// @INFO there values are used in multiple styled components
// the purpose is to do not use magic values and
// be able to edit multiple styles by editing those consts only

export const CONVERSATION_LEFT_PADDING = 50;
export const CONVERSATION_RIGHT_PADDING = 20;

// message container padding, every side
export const MESSAGE_PADDING = 5;

// container of user avatar, message date & re-try to send icon
export const MESSAGE_SIDEBAR_WIDTH = 50;

// gap between message sidebar and content
export const MESSAGE_SIDEBAR_RIGHT_MARGIN = 2;

// right sidebar; collapsible members list
export const SIDEBAR_WIDTH = 185;
